import { render, staticRenderFns } from "./desgloseunidad.vue?vue&type=template&id=a0711798"
import script from "./desgloseunidad.vue?vue&type=script&lang=js"
export * from "./desgloseunidad.vue?vue&type=script&lang=js"
import style0 from "./desgloseunidad.vue?vue&type=style&index=0&id=a0711798&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports